export enum ServiceBilledTo {
  Patient = "patient",
  OHIP = "ohip",
  WSIB = "wsib",
  ThirdParty = "third-party",
  ServiceCanada = "service-canada",
  DocnoteDebit = "docnote-debit",
  PrescriptionRefill = "prescription-refill",
}

export enum ServiceBilledToName {
  "patient" = "Patient",
  "ohip" = "OHIP",
  "wsib" = "WSIB",
  "third-party" = "3rd Party",
  "service-canada" = "Service Canada",
  "docnote-debit" = "Docnote Debit",
  "prescription-refill" = "Prescription Refill",
}

export enum AnnualPlanBilledToName {
  "Single" = "Individual Plan",
  "Senior Couple" = "Senior Couples Plan",
  "Family" = "Family Plan",
  "Couple" = "Couples Plan",
  "Senior" = "Senior Individual Plan",
}

export enum ServiceOwner {
  System = "system",
  Office = "office",
}

export type Service = {
  serviceId?: string;
  officeId?: string;
  sampleFileId?: string;
  name: string;
  description?: string;
  price: number;
  addTax: boolean;
  serviceBilledTo?: ServiceBilledTo;
  enabled: boolean;
  blockFeeDiscountPct?: number;
  annualPlanDiscountPct?: number;
  annualPlanEnabled?: boolean;
  uninsured?: boolean;
  featured?: boolean;
};
